export default "__VITE_ASSET__vS8B0WXx__"